import { Config } from '@backstage/config';
import { OAuthApi } from '@backstage/core-plugin-api';
import { getUserAccessToken } from './azureTokenManager';
import { AccountResult } from './workloadClientTypes';

export interface workloadResponse<T> {
  response: Response;
  json: () => Promise<T>;
}

const getJson = async <T,>(response: Response): Promise<T> =>
  (await response.json()) as T;

export class WorkloadClient {
  private readonly backendBaseUrl: string;
  private readonly oauthAPI: OAuthApi;

  constructor(config: Config, oauthAPI: OAuthApi) {
    this.backendBaseUrl = config.get('backend.baseUrl');
    this.oauthAPI = oauthAPI;
  }

  async fetchWorkloadData(
    accountId: string,
  ): Promise<workloadResponse<AccountResult>> {
    const response = await this.apiFetch(`workloads/${accountId}`);

    return {
      response,
      json: () => getJson<AccountResult>(response),
    };
  }

  async apiFetch(
    resource: string,
    method?: string,
    body?: any,
  ): Promise<Response> {
    let method_to_call = method;
    if (typeof method === 'undefined') {
      method_to_call = 'GET';
    }

    const userToken = await getUserAccessToken(
      this.oauthAPI,
      getAudForEnv(),
      getDefaultUserScopes(),
    );
    const options: RequestInit = {
      method: method_to_call,
      headers: { Authorization: `Bearer ${userToken}` },
    };
    if (body) {
      options.body = JSON.stringify(body);
    }

    return await fetch(
      `${this.backendBaseUrl}/api/proxy/aws-workload-auth/${resource}`,
      options,
    );
  }
}

export function getDefaultUserScopes(): string[] {
  const ApiAud = getAudForEnv();
  return [
    `api://${ApiAud}/workloads:accounts:update.own`,
    `api://${ApiAud}/workloads:accounts:request`,
    `api://${ApiAud}/sandbox:accounts:request`,
  ];
}

export function getAudForEnv(): string {
  const currURL = window.location.origin;

  if (
    currURL.indexOf('staging.') < 0 &&
    currURL.indexOf('dev.') < 0 &&
    currURL.indexOf('int.') < 0 &&
    currURL.indexOf('localhost') < 0
  ) {
    return 'foundation.admin.cloudmanagement';
  }
  return 'foundation.admin.cloudmanagement.test';
}
